const TAG_REGEX = /(<([^>]+)>)/gi;

class ConversationDownload {
    constructor(){
    }

    // 대화내역을 파라미터로 받아 csv파일로 생성 
    makeConversationFileWithData(fileName, rowDataList, conversationDataList){
      console.log(rowDataList);
      console.log(conversationDataList);
      this.makeCsvFile(fileName, this.makeRowString(rowDataList, conversationDataList));
    }

    // DB에서 대화내역을 가져와 csv 파일로 생성
    // 예) scheduleId = id1, id2, id3 혹은 id
    //     itemIndex = idx1, idx2, idx3 혹은 idx
    getAndMakeConversationFile(pageId, fileName, rowdataList) {
      // query parameter
      //console.log("getAndMakeConversationFile");
      let conversationDataAsk = {
        convKeyList: [],
      }
      rowdataList.forEach(obj => {
        conversationDataAsk.convKeyList.push({"requestId":obj.scheduleId, "outcallId":obj.itemIndex})
      });

      var conversationData = [];
      http.request(pageId, 'DTS_AIC_00019', {
        data: conversationDataAsk,
      }).then((response) => {
        console.log(response.data.list);
        conversationData = response.data.list.reduce((newObj, obj) => {
          obj.convList.forEach(list => {
            list.msgTime = this.changeTimeZoneAndFormat(list.msgTime)
            list.msg = list.msg.replaceAll(TAG_REGEX, '')
          });
          newObj[obj.convKey] = obj.convList;
          return newObj;
        }, {});   
        return this.makeRowString(rowdataList, conversationData);
      }).then(result => {
        this.makeCsvFile(fileName, result);
      });

    }

    // conversationData : key(requestId_itemIndex) - object 
    // rowData 
    makeRowString(rowData, conversationData) {
      var csvArray = [];
      
      // set header
      const header = ['세션ID', '캠페인', '시나리오', '수신번호', '시도순서', '상담원 요청', '예약', '시나리오 시작', '시나리오 종료', '발화자', '메시지(AICC)', '메시지(User)', '시간'];
      csvArray.push(header);

      // set data - row에 맞는 conversation data를 가져와 만든다
      var rowDataArray = [];
      rowData.forEach(row => {
        
        var conversationDataSet = conversationData[row.scheduleId+'_'+row.itemIndex];
        if(conversationDataSet.length>0){
          var rowItem = [];
          rowItem.push(conversationDataSet[0].sessionId); // Session Num
          rowItem.push(row.scheduleName);
          rowItem.push(row.scenarioName);
          rowItem.push(row.calleeNumber);
          rowItem.push(row.retryTimes);
          rowItem.push(row.callTxMark === 'Y'? 'Y' : '-');
          rowItem.push(row.insertReason === 'B'? 'Y' : '-');
          rowItem.push(row.scenarioStartEnd.start === 'Y'? 'Y' : '-');
          rowItem.push(row.scenarioStartEnd.end === 'Y'? 'Y' : '-');
          var convstart = false;
          conversationDataSet.forEach(convItem => {
            if(convItem.msgFlag === '3'){ return;} // session manager 값으로 출력하지 않는다
            var rowItemConvPart = [];
            rowItem.forEach(item => {rowItemConvPart.push(item)});
            var flag = convItem.msgFlag === '1'?'User':'AICC';
            rowItemConvPart.push(flag);
            // double quote 추가
            var regExp = /\"/gi;
            convItem.msg= convItem.msg.replaceAll(regExp, "\"\"");
            console.log(convItem.msg);
            if(convItem.msgFlag === '1') { // User의 메시지인 경우 메시지(AICC) 컬럼은 빈칸으로
              rowItemConvPart.push('');
              rowItemConvPart.push(convItem.msg);
            } else { // AICC의 메시지인 경우 메시지(User) 컬럼은 빈칸으로
              rowItemConvPart.push(convItem.msg);
              rowItemConvPart.push('');
            }
            // 엑셀프로그램에서 초단위까지 기본 표시되도록 탭 추가
            var msgTime = utils.toStringByFormat(convItem.msgTime, 'YYYY-MM-DD HH:mm:ss')+'\t';
            rowItemConvPart.push(msgTime);
            rowDataArray.push(rowItemConvPart);
          })
        }
      });
      csvArray = csvArray.concat(aiccUtils.stringUtil.enclose2DArrayInDoubleQuotes(rowDataArray));
      console.log(csvArray);
      return csvArray;
    }

    makeCsvFile(fileName, csvArray) {
      var blob, csvUrl, a;
      console.log(csvArray);
      const BOM = "\uFEFF";
      var csvString = BOM + csvArray.map(r=>r.join(",")).join("\r\n");
      blob = new Blob([csvString], { type: 'text/csv;charset=utf8' });
      csvUrl = URL.createObjectURL(blob);
      a = document.createElement('a');
      a.setAttribute('style', 'display:none');
      a.setAttribute('href', csvUrl);
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click()
      a.remove();
    }

    // 그리니치 기준시를 서울 기준시로 변경(+9)
    // 출력 포맷이 있을경우 포맷 스트링으로
    // 없을경우 +9 기준 date 리턴
    changeTimeZoneAndFormat(gmt0String, format){
      if(!gmt0String){
        return "";
      }
      var gmt0 = new Date(gmt0String);
      var gmt9 = new Date(gmt0.getTime() + (540 * 60 * 1000));
      if(format){
        return utils.toStringByFormat(gmt9, format);
      }else{
        return gmt9;
      }
    }
}

export default ConversationDownload;